import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { Text } from './Text.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
import { typography } from '../../node_modules/@styled-system/typography/dist/index.esm.js';
var prefix = "label";
var Label = styled(Text)(variant({
  prop: "size",
  variants: {
    md: {
      fontSize: "".concat(prefix, ".md"),
      lineHeight: "".concat(prefix, ".md"),
      letterSpacing: "sm"
    },
    sm: {
      fontSize: "".concat(prefix, ".sm"),
      lineHeight: "".concat(prefix, ".sm"),
      letterSpacing: "sm"
    },
    xs: {
      fontSize: "".concat(prefix, ".xs"),
      lineHeight: "".concat(prefix, ".xs"),
      letterSpacing: "sm"
    }
  }
}), variant({
  prop: "weight",
  variants: {
    base: {
      fontWeight: "".concat(prefix, ".base")
    },
    heavy: {
      fontWeight: "".concat(prefix, ".heavy")
    }
  }
}), typography);
Label.defaultProps = {
  size: "md",
  weight: "base"
};
export { Label };